import React, { Component } from 'react';
import { Link } from 'react-router-dom';

import { Grid } from 'components/grid';
import { I18n } from 'components/translate';
import { ROUTES } from 'configs/routes/constants';

export default class BroadcastEmptyContent extends Component {
  render() {
    return (
      <Grid block>
        <div className="empty__list">
          <div className="empty__list__icon">
            <i className="icon icon-empty" />
          </div>
          <div className="empty__list__title">
            <I18n label="broadcast.empty.still_sent_any_broadcast" />
          </div>
          <div className="empty__list__Description">
            <I18n label="broadcast.empty.to_send_broadcast_click_in" />
            <Link to={ROUTES.BROADCAST.NEW}>
              <I18n label="broadcast.add_broadcast" />
            </Link>
          </div>
        </div>
      </Grid>
    );
  }
}
